export default {
    generalSettings: 'Réglages Généraux',
    changeDisplayLanguage: 'Langue d\'affichage',
    changeDisplayLanguageInfo: 'Choisissez votre langue par défaut préférée',
    nav: {
        audits: 'Audits',
        vulnerabilities: 'Vulnérabilités',
        data: 'Données',
    },
    btn: {
        cancel: 'Annuler',
        confirm: 'Confirmer',
        create: 'Créer',
        restore: 'Restaurer',
        ok: 'ok',
        leave: 'Partir',
        stay: 'Rester',
        generateAnyway: 'Générer quand même',
        topButtonSection: {
            submitReview: 'Soumettre les modifications',
            cancelReview: 'Annuler les modifications',
            approve: 'Accepter',
            removeApproval: 'Retirer l\'approbation',
            createRetest: 'Créer un Retest',
            navigateRetest: 'Accéder au Retest'
        },
        backupFinding: "Proposer la création  / Mettre à jour dans la base de données",
        delete: 'Supprimer',
        save: 'Sauvegarder',
        saved: 'Sauvegardé',
        update: 'Modifier',
        deleteAll: 'Tout Supprimer',
        close: 'Close',
        enable: 'Activer',
        disable: 'Désactiver',
        valid: 'Validées',
        new: 'Nouvelles',
        updates: 'Modifiées',
        updatesAvailable: 'Mises à jour disponibles',
        dismissAllUpdates: 'Rejeter toutes les propositions en {language}',
        dismissProposal: 'Rejeter la proposition',
        dismissEveryUpdate: 'Rejeter toutes les propositions',
        accountEnabled: 'Compte activé',
        accountDisabled: 'Compte désactivé',
        qa: 'QA',
        comments: 'Commentaires',
        discard: 'Abandonner',
    },
    tooltip: {
        vulnerabilityUpdates: 'Consulter les propositions de mise à jour de cette vulnérabilité',
        usersConnected: 'Utilisateurs sur l\'Audit:',
        editAudit: 'Modifier l\'Audit',
        downloadReport: 'Télécharger le Rapport',
        downloadReportWithUnsavedDrafts: 'Des modifications locales récupérées existent et ne seront pas incluses dans le rapport tant qu\'elles ne sont pas enregistrées',
        auditDraftUnsavedChanges: 'Des modifications locales récupérées existent',
        deleteAudit: 'Supprimer l\'Audit',
        removeAudit: 'Retirer l\'Audit (l\'Audit ne sera pas supprimé)',
        topButtonSection: {
            submitReview: 'Marquer l\'audit comme prêt pour examin',
            cancelReview: 'Apporter des modifications à l\'audit',
            approve: 'Approuver cet audit',
            removeApproval: 'Retirer l\'approbation',
            createRetest: 'Créer un Retest pour cet Audit',
            navigateRetest: 'Naviguer vers le Retest de cet Audit'
        },
        sortOptions: 'Options de tri',
        addToFindings: 'Ajouter aux découvertes',
        edit: 'Modifier',
        view: 'Voir',
        findAudits: 'Rechercher des Audits',
        delete: 'Supprimer',
        download: 'Télécharger',
        retestSplitView: 'Activer la vue partagée avec les données de la vulnérabilité originale',
        addAudit: 'Ajouter l\'Audit',
        restoreRevert: "Restaure à l'état de la sauvegarde. Toutes les données non présentes dans la sauvegarde seront effacées",
        restoreUpsert: "Restaure les données de la sauvegarde et met à jour les données existantes. Si les données existent déjà, elles seront mises à jour, sinon elles seront crées",
        auditQa: 'Afficher le panneau QA',
        vulnerabilityQa: 'Afficher le panneau QA',
    },
    msg: {
        auditReviewUpdateOk: 'État de l\'examin d\'audit mis à jour avec succès',
        auditApprovalUpdateOk: 'L\'approbation de l\'audit a été mise à jour avec succès',
        auditUpdateOk: 'Audit mis à jour avec succès',
        findingCreateOk: 'Découverte créée avec succès',
        findingUpdateOk: 'Découverte modifiée avec succès',
        findingDeleteOk: 'Découverte supprimée avec succès',
        doYouWantToLeave: 'Voulez-vous vraiment partir ?',
        thereAreUnsavedChanges: 'Il y a des modifications non enregistrées !',
        auditDraftDownloadWarningTitle: 'Des modifications locales récupérées existent',
        auditDraftDownloadWarningMessage: 'Cet audit contient des modifications locales récupérées qui ne sont pas enregistrées sur le serveur. Elles ne seront pas incluses dans le rapport généré tant que vous ne les aurez pas enregistrées.',
        fieldRequired: 'Veuillez remplir tous les champs obligatoires',
        deleteFindingConfirm: 'Supprimer la découverte actuelle ?',
        deleteFindingNotice: 'Cette action ne peut pas être annulée',
        selectHost: 'Sélectionnez les hôtes',
        importHostsFirst: 'Saisir les hôtes en premier',
        auditTypeNotSet: 'Type d\'audit non défini',
        sectionUpdateOk: 'Section mise à jour avec succès',
        lastnameRequired: 'Nom requis',
        firstnameRequired: 'Prénom requis',
        emailRequired: 'E-mail requis',
        clientCreatedOk: 'Client créé avec succès',
        clientUpdatedOk: 'Client modifié avec succès',
        clientDeletedOk: 'Client supprimé avec succès',
        deleteNotice: 'sera définitivement supprimé',
        confirmSuppression: 'Confirmer la suppression',
        confirmRestore: 'Confirmer la restauration',
        restoreNotice: 'sera restaurée et pourrait mener à la perte des données existantes',
        usernameRequired: 'Nom d\'utilisateur requis',
        passwordRequired: 'Mot de passe requis',
        currentPasswordRequired: 'Mot de passe actuel requis',
        confirmPasswordDifferents: 'Le nouveau mot de passe et la confirmation du mot de passe sont différents',
        collaboratorCreatedOk: 'Collaborateur créé avec succès',
        collaboratorUpdatedOk: 'Collaborator modifié avec succès',
                roleCreatedOk: 'Role created successfully',
        roleUpdatedOk: 'Role updated successfully',
        roleDeletedOk: 'Role deleted successfully',
        roleDisplayNameRequired: 'Role display name required',
        roleNameRequired: 'Role name required',
        usersUpdatedOk: 'Users updated successfully',
        nameRequired: 'Nom requis',
        fileRequired: 'Fichier requis',
        companyCreatedOk: 'Entreprise créée avec succès',
        companyUpdatedOk: 'Entreprise modifiée avec succès',
        companyDeletedOk: 'Entreprise supprimée avec succès',
        templateNotFound: 'Modèle introuvable',
        templateCreatedOk: 'Modèle créé avec succès',
        templateUpdatedOk: 'Modèle modifié avec succès',
        allVulnerabilitesDeleteNotice: 'Toutes les vulnérabilités seront définitivement supprimées',
        allVulnerabilitesDeleteOk: 'Toutes les vulnérabilités ont été supprimées avec succès',
        profileUpdateOk: 'Mise à jour du profil réussie',
        settingsUpdatedOk: 'Paramètres mis à jour avec succès',
        revertingSettings: 'Rétablir les paramètres ! ',
        revertingSettingsConfirm: 'Souhaitez-vous vraiment rétablir les paramètres par défaut ? Vous perdrez tous les paramètres actuels.',
        importingSettings: 'Importation des paramètres !',
        importingSettingsConfirm: 'Souhaitez-vous vraiment importer les nouveaux paramètres ? Vous perdrez tous les paramètres actuels qui sont remplacés.',
        settingsImportedOk: 'Paramètres importés avec succès',
        vulnerabilityCreatedOk: 'Vulnerabilité créée avec succès',
        vulnerabilityUpdatedOk: 'Vulnerabilité modifiée avec succès',
        vulnerabilityDeletedOk: 'Vulnerabilité supprimée avec succès',
        vulnerabilityWillBeDeleted: 'La vulnérabilité sera définitivement supprimée',
        updatesDismissedOk: 'Propositions de mise à jour rejetées avec succès',
        confirmDismissUpdates: 'Confirmer le rejet',
        updatesWillBeDismissed: 'Toutes les propositions en {language} seront définitivement supprimées',
        updateWillBeDismissed: 'La proposition de {creator} sera définitivement supprimée',
        everyUpdateWillBeDismissed: 'Toutes les propositions de cette vulnérabilité seront définitivement supprimées, dans toutes les langues',
        confirmCategoryChange: 'Confirmer le changement de catégorie',
        categoryChangingNotice: 'L\'affichage des champs personnalisés peut être affecté lors du changement de catégorie',
        vulnerabilityMergeOk: 'Fusion des vulnérabilités réussie',
        tryingToContactBackend: '<p>Essaie de contacter le backend</p>',
        wrongContactingBackend: 'Une erreur s\'est produite lors du contact avec le backend',
        highlightWarningTitle: 'Texte Surligné toujours présent !',
        noAuditTypeForThisStage: 'Aucun type d\'Audit pour cette phase'
    },
    err: {
        notDefinedLanguage: 'Non défini pour cette langue',
        invalidYamlFormat: 'Format YAML invalide détecté',
        parsingError1: 'Erreur de parsing: {0}',
        parsingError2: 'Erreur de parsing: line {0}, column: {1}',
        invalidJsonFormat: 'Format JSON invalide détecté',
        jsonMustBeAnObject: 'JSON doit être un objet.',
        importingSettingsError: 'Erreur lors de l\'importation des paramètres',
        errorWhileParsingJsonContent: 'Erreur lors du parsing du contenu JSON : {0}',
        titleRequired: 'Titre requis',
        expiredToken: 'Token expiré',
        invalidToken: 'Token invalide',
        invalidCredentials: 'Identifiants invalides',
    },
    cvss: {
        title: 'Score de base CVSSv3',
        infoWhenNoScore: 'Sélectionnez des valeurs pour toutes les métriques de base pour générer un score ',
        attackVector: 'Vecteur d\'attaque',
        attackComplexity: 'Complexité d\'attaque',
        privilegesRequired: 'Privilèges requis',
        userInteraction: 'Interaction de l\'utilisateur',
        scope: 'Périmètre',
        confidentialityImpact: 'Impact sur la Confidentialité',
        integrityImpact: 'Impact sur la Intégrité',
        availabilityImpact: 'Impact sur la Disponibilité',
        network: 'Réseau',
        adjacentNetwork: 'Réseau Adjacent',
        local: 'Local',
        physical: 'Physique',
        low: 'Bas',
        high: 'Haut',
        none: 'Nul',
        required: 'Requis',
        unchanged: 'Inchangé',
        changed: 'Changé',
    },
    registerFirstUser: 'Enregistrer le premier utilisateur',
    customData: 'Données Personnalisées',
    custom: 'Personnalisé',
    settings: 'Paramètres',
    profile: 'Profil',
    logout: 'Déconnexion',
    login: 'Connexion',
    username: 'Nom d\'utilisateur',
    password: 'Mot de passe',
    noLanguage: 'Aucune Langue n\'est définie. Veuillez créer des Langues dans ',
    noAudit: 'Aucun type d\'Audit n\'est défini. Veuillez créer des types d\'Audit dans ',
    auditTypes: 'Types d\'Audit',
    auditType: 'Type d\'Audit',
    searchFinds: 'Rechercher une découverte',
    myAudits: 'Mes Audits',
    usersConnected: 'Utilisateur Connecté',
    awaitingMyReview: 'En attente de mon examin',
    newAudit: 'Nouvel Audit',
    search: 'Rechercher',
    searchUsersPlaceholder: 'Rechercher par nom, e-mail ou nom d\'utilisateur...',
    any: 'Tous',
    all: 'Tout',
    status: 'Statut',
    actions: 'Actions',
    statusActive: 'Actif',
    statusDisabled: 'Désactivé',
    enabled: 'activée',
    disabled: 'désactivée',
    showing: 'Affichage de',
    to: 'à',
    of: 'sur',
    user: 'Utilisateur',
    users: 'Utilisateurs',
    userSelected: 'utilisateur sélectionné',
    usersSelected: 'utilisateurs sélectionnés',
    allRoles: 'Tous les rôles',
    twoFactorAuthentication: '2FA',
    forThisUser: 'pour cet utilisateur',
    disableUsersWarning: 'Les utilisateurs désactivés ne pourront plus se connecter ni accéder au système. Vous pouvez les réactiver à tout moment.',
    auditNum1: 'Audit',
    auditNums: 'Audits',
    resultsPerPage: 'Resultats par page:',
    createAudit: 'Créer un Audit',
    name: 'Nom',
    selectAssessment: 'Sélectionnez le type d\'Audit',
    selectLanguage: 'Choisir la langue',
    participants: 'Participants',
    language: 'Langue',
    company: 'Entreprise',
    companies: 'Entreprises',
    date: 'Date',
    sections: 'Sections',
    generalInformation: 'Informations Générales',
    networkScan: 'Scan Réseau',
    findings: 'Découvertes',
    automaticSorting: 'Tri automatique',
    sortBy: 'Trier Par',
    sortOrder: 'Ordre de tri',
    ascending: 'Croissant',
    descending: 'Décroissant',
    newestFirst: 'Plus récent',
    oldestFirst: 'Plus ancien',
    me: 'moi',
    cvssScore: 'Score CVSS',
    priority: 'Priorité',
    remediation: 'Remédiation',
    remediationDifficulty: 'Difficulté de Remédiation',
    remediationComplexity: 'Complexité de Remédiation',
    remediationPriority: 'Priorité de Remédiation',
    easy: 'Facile',
    medium: 'Moyenne',
    complex: 'Complexe',
    low: 'Basse',
    high: 'Haute',
    urgent: 'Urgente',
    title: 'Titre',
    category: 'Categorie',
    selectCategory: 'Choisir une catégorie',
    noCategory: 'Aucune catégorie',
    vulnType: 'Type',
    undefined: 'Non défini',
    vulnerabilityNum1: 'Vulnerabilité',
    vulnerabilitiesNums: 'Vulnerabilités',
    definition: 'Définition',
    proofs: 'Preuves',
    details: 'Détails',
    completed: 'Completé',
    type: 'Type',
    lastModified: 'Dernière modification',
    description: 'Description',
    observation: 'Observation',
    references: 'Références',
    one_per_line: '(Une par ligne)',
    customFields: 'Champs Personnalisés',
    affectedAssets: 'Actifs Impactés',
    courseOfActions: 'Plan d\'action',
    template: 'Modèle',
    client: 'Client',
    reviewers: 'Examinateurs',
    collaborator: 'Collaborateur',
    collaborators: 'Collaborateurs',
    startDate: 'Date de départ',
    endDate: 'Date de fin',
    reportingDate: 'Date de rapport',
    auditScope: 'Périmètre audité (Un hôte par ligne)',
    import: 'Importer',
    export: 'Exporter',
    hostsAssociateScopes: 'Associer des hôtes "importés" au périmètre défini',
    handleCustomData: 'Gérer les Données Personnalisées',
    clients: 'Clients',
    templates: 'Modèles',
    addClient: 'Ajouter un Client',
    editClient: 'Modifier un Client',
    firstname: 'Prénom',
    lastname: 'Nom',
    email: 'E-mail',
    function: 'Fonction',
    phone: 'Téléphone',
    cell: 'Portable',
    jobTitle: 'Titre du poste',
    role: 'Rôle',
    collatorator: 'Collaborateur',
    addCollaborator: 'Ajouter un Collaborateur',
    editCollaborator: 'Modifier un Collaborateur',
    addCompany: 'Ajouter une Entreprise',
    editCompany: 'Modifier une Entreprise',
    logo: 'Logo',
    quantifier: '',
    languages: 'Langues',
    extension: 'Extension',
    createTemplate: 'Créer un Modèle',
    file: 'Fichier',
    editTemplate: 'Modifier un Modèle',
    importVulnerabilities: 'Importer des vulnérabilités',
    importVulnerabilitiesInfo: `Importez des vulnérabilités à partir d'un fichier .yml ou .json. (Format Serpico accepté)<br />
    Cela vous permet d'importer facilement un lot de modèles de vulnérabilités.`,
    importVulnerabilitiesOk: 'Les <strong>{0}</strong> vulnerabilités ont été créées',
    importVulnerabilitiesAllExists: 'Les <strong>{0}</strong> titres des vulnérabilités existent déjà',
    importVulnerabilitiesPartial: '<strong>{0}</strong> vulnérabilités créées<br /><strong>{1}</strong> titres des vulnérabilités existent déjà',
    exportVulnerabilities: 'Exporter les Vulnerabilités',
    exportVulnerabilitiesInfo: `Exporter les Vulnerabilités au format yaml. Cet export peut être facilement réimporté par la suite`,
    deleteAllVulnerabilities: 'Supprimer toutes les vulnérabilités',
    deleteAllVulnerabilitiesInfo: `Supprimer toutes les vulnérabilités existantes. <br />
    <strong>Cette action est définitive !!</strong>`,
    customSections: 'Sections personnalisées',
    listOfLanguages: 'Liste des Langues',
    editLanguages: 'Modifier les Langues',
    locale: 'Locale',
    auditTypesUsedInAudits: 'Types d\'Audit utilisés dans les Audits',
    languageUsedInAuditsAndVuls: 'Langues utilisées dans les audits et les vulnérabilités',
    addSections: 'Ajouter des Sections',
    hideBuiltInSections: 'Masquer les Sections Natives',
    listOfAuditTypes: 'Liste des Types d\'Audit',
    editAuditTypes: 'Modifier les Types d\'Audit',
    createAtLeastOneLanguage: 'Veuillez créer au moins une Langue',
    createVulnerabilityTypes: 'Créer des types de Vulnérabilité utilisés dans Vulnérabilités et Découvertes',
    vulnerabilityTypesList: 'Liste des types de Vulnérabilité',
    editVulnerabilityTypes: 'Modifier les types de Vulnérabilité',
    createVulnerabilityCategories: 'Créer des catégories de vulnérabilité utilisées dans Vulnérabilités et Découvertes',
    defaultSortingOptions: 'Options de Tri par Défaut',
    listOfCategories: 'Liste des Catégories',
    editCategories: 'Modifier les Catégories',
    createAndManageCustomFields: 'Créer et Gérer des Champs Personnalisés pour différentes Vues',
    selectView: 'Sélectionner une Vue',
    selectSection: 'Sélectionner une Section',
    selectComponent: 'Sélectionner un Composant',
    label: 'Label',
    size: 'Taille',
    offset: 'Décalage',
    required: 'Requis',
    optionsLanguage: 'Options de Langue',
    addOption: 'Ajouter une Option',
    languageForDefaultText: 'Langue (Pour le texte par défaut)',
    createCustomSections: 'Créer des sections personnalisées utilisées dans les Audits',
    fieldForTemplate: 'Champs (Pour les Modèles)',
    customIcon: 'Icons (Material/Font Awesome)',
    field: 'Champs',
    editSections: 'Modifier les Sections',
    vulnerabilityTypes: 'Types de Vulnérabilités',
    vulnerabilityCategories: 'Catégories de Vulnérabilité',
    auditGeneral: 'Audit General',
    auditFinding: 'Découverte d\'Audit',
    auditSection: 'Section d\'Audit',
    vulnerability: 'Vulnerabilité',
    checkbox: 'Checkbox',
    editor: 'Editeur',
    input: 'Input',
    radio: 'Radio',
    select: 'Select',
    selectMultiple: 'Sélectionner Plusieurs',
    space: 'Espace',
    updateUserInformation: 'Mettre à jour les Informations de l\'Utilisateur',
    newPassword: 'Nouveau Mot de Passe',
    confirmPassword: 'Confirmez le mot de passe ',
    currentPassword: 'Mot de passe actuel *',
    reports: 'Rapports',
    reportsImagesBorder: 'Bordures d\'Images de Rapport',
    addBorderToImages: 'Ajouter une bordure aux images dans le rapport généré.',
    currentColor: 'Couleur actuelle',
    cvssColors: 'Couleurs du CVSS',
    changeCvssColorsDescription: 'Modifier les couleurs utilisées dans le rapport pour représenter les différentes sévérités CVSS.',
    critical: 'Critique',
    informational: 'Informationnel',
    reviews: 'Commentaires',
    auditUpdateAfterApproval: 'Mise à jour de l\'Audit après Approbation',
    changeApproveBehaviorIfAuditUpdated: 'Modifier le comportement d\'un Audit approuvé qui est mis à jour. Si un audit est mis à jour: ',
    removeAllPriorApprovals: 'Toutes ses approbations préalables sont supprimées.',
    keepAllPriorApprovals: 'Toutes ses approbations préalables sont conservées.',
    mandatoryReview: 'Examen obligatoire',
    mandatoryReviewInfo: `Rend le processus de révision obligatoire. Lorsqu'il est activé, un utilisateur ne peut pas exporter un audit à moins qu'il n'ait été approuvé par le nombre spécifié d'examinateurs. 
    <br/>Le nombre minimal d'examinateurs est également utilisé pour déterminer si un rapport est marqué comme approuvé.`,
    minimalNumberOfReviewers: 'Nombre minimal d\'Examinateurs',
    saveSettings: 'Sauvegarder les paramètres',
    revertSettingsToDefaults: 'Rétablir les paramètres par défaut',
    importSettings: 'Importation des paramètres',
    exportSettings: 'Exportation des paramètres',
    mergeVulnerabilities: 'Fusionner les Vulnerabilités',
    mergeVulnerabilitiesInfo: `L'objectif est de fusionner différentes vulnérabilités dans différentes langues en une seule vulnérabilité.<br />
    Il doit donc exister un minimum de 2 langues.`,
    newVulnerability: 'Nouvelle vulnérabilité',
    createNewVulnerability: 'Créer une nouvelle vulnérabilité',
    filters: 'Filtres',
    views: 'Vues',
    or: 'ou',
    reset: 'Réinitialiser',
    createdBy: 'Créé par',
    filtersApplied: 'filtre(s) actif(s)',
    unsavedChangesOnly: 'Modifications non enregistrées uniquement',
    noMatchingRecords: 'Aucun résultat trouvé',
    selectVulnerability: 'Sélectionnez une vulnérabilité à afficher ou modifier',
    selectVulnerabilityHint: 'Choisissez une vulnérabilité dans la liste à gauche pour voir ses détails, son score CVSS, ses références et plus encore.',
    total: 'Total',
    addVulnerability: 'Ajouter une Vulnérabilité',
    editVulnerability: 'Modifier une Vulnérabilité',
    changeCategory: 'Changer la Categorie',
    listOfSections: 'Liste des Sections',
    updateVulnerability: 'Mettre à jour la Vulnerabilité',
    current: 'Courant',
    proposalsCount: '{count} proposition | {count} propositions',
    reviewVulnerabilityProposals: 'Examiner les propositions de vulnérabilité',
    currentVersion: 'Version actuelle',
    proposedVersion: 'Version proposée',
    today: "Aujourd'hui",
    yesterday: 'Hier',
    languageAddFromRight: 'Langue (Ajouter à partir de la droite)',
    languageMoveToLeft: 'Langue (Déplacer vers la gauche)',
    merge: 'Fusionner',
    goBack: 'Revenir en arrière',
    twoStepVerification: 'Vérification en 2 étapes',
    twoStepVerificationMessage: "Ouvrez votre application d'authentification et entrez le code de sécurité correspondant.",
    captions: 'Légendes',
    captionsDescription: 'Ajouter les valeurs des différentes légendes qui seront utilisés dans le rapport (\'Figure\' par défaut).',
    highlightWarning: 'Alerte de Texte Surligné',
    highlightWarningDescription: `Ajoute un message d'avertissement lors de l'édition d'un rapport et que du texte surligné avec la couleur choisie est toujours présent.<br />
    Utile pour du texte générique qui devrait être remplacé par le rédacteur.`,
    defaultFieldsRequired: 'Champs par défaut',
    defaultFieldsRequiredDescription: 'Gestion des champs par défaut requis dans la section Audits',
    general: 'Général',
    scope: 'Périmètre',
    fieldIsRequired: 'Ce champ est requis',
    corrected: 'Corrigé',
    not_corrected: 'Non Corrigé',
    partially_corrected: 'Partiellement Corrigé',
    not_verifiable: 'Non Vérifiable',
    audits: 'Audits',
    multi: 'Multi-Phases',
    retest: 'Retest',
    default: 'Default',
    audit: 'Audit',
    originalAudit: 'Audit Original',
    willBeRemoved: 'sera retiré',
    auditPhase: 'Phase d\'Audit',
    upload: 'Importer',
    // Settings Backups
    backup: 'Sauvegarde',
    backups: 'Sauvegardes',
    backupInProgress: 'Sauvegarde en cours',
    backupOptions: 'Options de Sauvegarde',
    backupType: 'Type de Sauvegarde',
    createBackup: 'Créer Sauvegarde',
    customers: 'Clientèle',
    enableEncryption: 'Activer le chiffrement',
    full: 'Totalité',
    fullBackup: 'Sauvegarde totale',
    includeVulnerabilitiesUpdates: 'Inclure les propositions de mise à jour de vulnérabilités',
    listBackupDescription: 'Liste des sauvegardes disponibles sur le serveur',
    listBackups: 'Liste des Sauvegardes',
    neededForAuditTypes: "Requis pour les Types d'Audit",
    neededForClients: 'Requis pour les Clients',
    neededForUsers: 'Requis pour les Utilisateurs',
    neededForVulnUpdates: 'Requis pour les propositions de mise à jour de vulnérabilités',
    partial: 'Partiel',
    partialBackup: 'Sauvegarde Partielle',
    refresh: 'Rafraichir',
    restore: 'Restaurer',
    restoreInProgress: 'Restauration en cours',
    restoreMode: 'Mode de Restauration',
    revert: 'Rétablir',
    selectWhatToRestore: 'Sélectionner quoi restaurer',
    upsert: 'Mettre à jour et insérer',
    vulnerabilities: 'Vulnérabilités',
    wrongFileFormat: 'Format de fichier incorrect',
    // Backups Statuses
    backup_started: 'Sauvegarde démarrée',
    backup_uploading: 'Importation de la sauvegarde en cours',
    dumping_database: 'Extraction de la base de donnée 1/3',
    building_data: 'Compilation des données 2/3',
    encrypting_data: 'Chiffrement des données 2.5/3',
    building_archive: "Construction de l'archive 3/3",
    backup_error: 'Erreur de Sauvegarde',
    restore_started: 'Restauration démarrée',
    extracting_info: 'Extraction des informations 1/3',
    decrypting_data: 'Déchiffrement des données 1.5/3',
    extracting_data: 'Extraction des données 2/3',
    restoring_data: 'Restoration des données 3/3',
    restore_error: 'La dernière restauration a généré une erreur',
    // Init restore message
    restoreFromBackup: 'Ou restaurer depuis un fichier de Sauvegarde',
    spellcheck: 'Correcteur orthographique',
    enableSpellcheck: 'Activer le correcteur',
    spellcheckCategories: 'Catégories',
    spellcheckCategory: {
        CASING: { label: 'Casse', description: 'Mauvaise capitalisation, ex. "anglais" au lieu de "Anglais"' },
        COMPOUNDING: { label: 'Composition', description: 'Erreurs avec les mots composés, ex. traits d\'union manquants' },
        GRAMMAR: { label: 'Grammaire', description: 'Erreurs grammaticales telles que formes verbales incorrectes' },
        TYPOS: { label: 'Fautes de frappe', description: 'Mots mal orthographiés et fautes de frappe courantes' },
        PUNCTUATION: { label: 'Ponctuation', description: 'Signes de ponctuation manquants ou incorrects' },
        TYPOGRAPHY: { label: 'Typographie', description: 'Problèmes typographiques comme des guillemets ou tirets incorrects' },
        CONFUSED_WORDS: { label: 'Mots confondus', description: 'Mots souvent confondus, ex. "a" vs "à"' },
        REPETITIONS: { label: 'Répétitions', description: 'Mots ou expressions involontairement répétés' },
        REDUNDANCY: { label: 'Redondance', description: 'Mots redondants n\'ajoutant aucune signification' },
        STYLE: { label: 'Style', description: 'Suggestions de style pour une écriture plus claire ou concise' },
        SEMANTICS: { label: 'Sémantique', description: 'Mots utilisés avec un sens incorrect' },
        COLLOQUIALISMS: { label: 'Expressions familières', description: 'Expressions informelles ou familières' },
        MISC: { label: 'Divers', description: 'Autres règles non couvertes par les catégories ci-dessus' },
    },
    draftRecovery: {
        title: 'Modifications récupérées',
        message: 'Examinez les différences entre vos modifications récupérées et la dernière version enregistrée.',
        savedAt: 'Enregistré localement le',
        currentVersion: 'Dernière version enregistrée',
        draftVersion: 'Vos modifications récupérées',
        noDifferences: 'Aucune différence trouvée',
        unifiedView: 'Unifié',
        splitView: 'Séparé',
        localDraftLabel: 'Modifications récupérées',
        serverVersionLabel: 'Version du serveur',
        localDraftExists: 'Des modifications récupérées existent',
        viewingLocalDraft: 'Vous consultez vos modifications récupérées',
        notSavedToServer: 'Enregistrez pour conserver vos modifications',
        viewingServerVersion: 'Vous consultez la dernière version enregistrée',
        localDraftNotApplied: 'Des modifications récupérées existent mais ne sont pas appliquées',
        draftExpiresIn: 'Expire dans',
        draftExpired: 'Expiré',
        clearedAfterInactivity: 'Récupérable jusque-là',
        discardDraft: 'Revenir à la version enregistrée',
        discardLocalChanges: 'Retourner à la dernière version enregistrée',
        viewChangesLabel: 'Voir les modifications',
        reviewChangesInDraft: 'Consulter les modifications dans ce brouillon',
        restoreDraftLabel: 'Restaurer les modifications récupérées',
        replaceWithDraft: 'Remplacer le contenu actuel par les modifications récupérées',
        deletePermanently: 'Supprimer définitivement les modifications récupérées',
        actionCannotBeUndone: 'Cette action est irréversible',
        compareWithDraft: 'Comparer la version enregistrée avec les modifications récupérées',
        saveHint: 'Utilisez Enregistrer (ctrl+s) dans la barre d\'outils pour sauvegarder vos modifications.',
        edited: 'Modifié',
        editedJustNow: 'Modifié à l\'instant'
    },
    roles: 'Roles',
    rolesPageSubtitle: 'Gérez les rôles et leurs permissions. Les rôles définissent ce que les utilisateurs peuvent consulter et modifier.',
    createRole: 'Create Role',
    editRole: 'Edit Role',
    viewRole: 'View Role',
    deleteRole: 'Delete Role',
    searchRolesPlaceholder: 'Rechercher des rôles...',
    allTypes: 'Tous les types',
    customRole: 'Personnalisé',
    adminRoleDescription: 'Accès complet à la plateforme. Gestion de tous les paramètres, utilisateurs et données.',
    userRoleDescription: 'Accès de base pour consulter les données assignées.',
    roleDescriptionFallback: 'Aucune description fournie.',
    allPermissions: 'Toutes les permissions',
    roleDisplayName: 'Display Name',
    roleName: 'Role Name',
    roleNameImmutableHint: 'Cannot be changed after creation',
    permissions: 'Permissions',
    coreAccess: 'Core Access',
    featurePermissions: 'Feature Permissions',
    cloneFrom: 'Clone From',
    searchPermissions: 'Rechercher des permissions...',
    selected: 'sélectionnées',
    assigned: 'assigned',
    expandAll: 'Tout développer',
    collapseAll: 'Tout réduire',
    clearAll: 'Tout effacer',
    noPermissionsFound: 'Aucune permission trouvée',
    systemRole: 'System',
    cannotEditSystemRole: 'System roles cannot be edited',
    usersWithRole: 'Users with this role',
    roleType: 'Type',
    addRoles: 'Add Roles',
    removeRoles: 'Remove Roles',
    bulkActionsSelected: 'Bulk actions selected',
    auditQa: {
        infos: 'Infos',
        title: 'Revue QA',
        loading: 'Chargement des résultats QA…',
        running: 'Exécution des vérifications QA...',
        runInProgress: 'QA en cours… démarrée {time}',
        runInProgressNoTime: 'QA en cours…',
        runInProgressProgrammatic: 'Vérifications automatiques en cours… démarrées {time}',
        runInProgressProgrammaticNoTime: 'Vérifications automatiques en cours…',
        runInProgressAi: 'Vérifications IA en cours… démarrées {time}',
        runInProgressAiNoTime: 'Vérifications IA en cours…',
        failed: 'Impossible d\'exécuter la revue QA du rapport',
        previousProgrammaticRun: 'Affichage des données des vérifications intégrées',
        previousProgrammaticRunAt: 'Affichage des données des vérifications intégrées ({date})',
        previousAiRun: 'Affichage des données des vérifications IA',
        previousAiRunAt: 'Affichage des données des vérifications IA ({date})',
        runSourceProgrammatic: 'Vérifications intégrées',
        runSourceAi: 'Vérifications IA',
        lastRun: 'Dernière exécution',
        noResultsYet: 'Aucun résultat QA pour le moment. Choisissez une option d\'exécution ci-dessus.',
        outdatedBanner: 'Ces résultats sont obsolètes — le contenu a changé depuis la dernière exécution. Une nouvelle exécution est recommandée.',
        runProgrammatic: 'Exécuter les vérifications intégrées',
        runAi: 'Exécuter les vérifications IA',
        runAll: 'Exécuter les vérifications intégrées + IA',
        runAgain: 'Relancer',
        runAgainScoped: 'Relancer {scope}',
        scopeProgrammatic: 'Vérifications intégrées',
        scopeAi: 'Vérifications IA',
        scopeAll: 'Vérifications intégrées + IA',
        errors: 'Erreurs',
        warnings: 'Avertissements',
        total: 'Total',
        filterAll: 'Tout',
        noIssues: 'Aucun problème signalé',
        goToFinding: 'Aller à la découverte',
        goToSection: 'Aller à la section',
        aiReview: 'Revue IA — vérifiez avant d\'agir',
        showMore: 'Afficher {count} de plus',
        category: {
            completeness: 'Complétude',
            redaction: 'Rédaction',
            customer: 'Client',
            instructions: 'Instructions QA',
            references: 'Références',
            imageCaptions: 'Légendes d\'images',
            duplicates: 'Doublons',
            aiDuplicates: 'Doublons IA',
            aiUnlinkedTranslations: 'Traductions non liées',
            other: 'Autre'
        },
        location: {
            general: 'Informations générales',
            network: 'Réseau',
            report: 'Rapport',
            untitledFinding: 'Découverte sans titre'
        }
    },
    vulnerabilityQa: {
        titleSingle: 'Revue QA',
        titleAll: 'Revue QA de la base de vulnérabilités',
        untitled: 'Vulnérabilité sans titre',
        loading: 'Chargement des résultats QA…',
        running: 'Analyse des vulnérabilités pour vérifier la complétude, les doublons, les liens de référence et les règles de contenu...',
        failed: 'Impossible d\'exécuter la revue QA des vulnérabilités',
        recheckFailed: 'Impossible de revérifier la vulnérabilité',
        showReview: 'Afficher la revue QA',
        hideReview: 'Masquer la revue QA',
        reviewedCount: '{count} vulnérabilités analysées pour la langue sélectionnée.',
        runAllPreview: 'Analyse les {count} vulnérabilités en {language} avec les vérifications de complétude, de doublons et IA. S\'exécute en arrière-plan — vous pouvez continuer à travailler.',
        progressTemplates: '{processed} vulnérabilités analysées sur {total}…',
        progressCatalog: 'Vérifications inter-vulnérabilités : {done} sur {total}…',
        reusedCached: '{count} résultat(s) inchangé(s) réutilisé(s)',
        partialReport: '{checked} vulnérabilités analysées sur {total} — relancez la QA pour examiner les restantes.',
        cancel: 'Annuler',
        recheckHint: 'Revérifie uniquement cette vulnérabilité. Les vérifications inter-vulnérabilités (doublons, traductions) ne sont pas incluses — utilisez « Relancer » pour celles-ci.',
        recheckUpToDate: 'À jour — aucune modification depuis la dernière exécution QA',
        runAgainHint: 'Seules les vulnérabilités obsolètes sont revérifiées',
        rowOutdated: 'obsolète',
        catalogGroup: 'Vérifications inter-vulnérabilités',
        goToVulnerability: 'Aller à la vulnérabilité',
        resolve: 'Résoudre cette vulnérabilité',
        resolveIssue: 'Résoudre ce problème',
        unresolve: 'Marquer comme non résolu',
        resolvedLabel: 'résolu',
        filterActive: 'Actif',
        filterOutdated: 'Obsolète',
        filterResolved: 'Résolu',
        filterAllStatus: 'Tout',
        filterRows: 'Filtrer par titre de vulnérabilité...',
        resolveFailed: 'Impossible de mettre à jour l\'état de résolution',
        clearFilters: 'Effacer les filtres',
        notFoundInList: 'Cette vulnérabilité n\'est plus dans la base de données — relancez la QA pour actualiser le rapport.',
        notVisibleWithFilters: 'Cette vulnérabilité est masquée par les filtres actuels.',
        location: {
            database: 'Base de vulnérabilités',
            global: 'Global'
        }
    },
    aiIntegration: {
        pageTitleWriting: 'Assisted Writing',
        pageTitleQa: 'Quality Assurance',
        disabledBanner: 'AI integration is disabled in organization settings. Enable it from Settings to manage assisted writing and quality assurance.',
        noPermissionBanner: 'You do not have permission to view {page} settings.',
        loadFailed: 'Failed to load AI integration settings',
        tabPrompts: 'Prompts',
        tabGuidelines: 'Writing Guidelines',
        tabProgrammaticChecks: 'Built-in Checks',
        tabAiChecks: 'AI Checks',
        prompts: {
            description: "Configure generic prompts for the AI chat and field-specific generation prompts. Provider and model settings are managed in Settings.",
            readOnly: 'Read-only: you do not have permission to update prompts.',
            genericPrompts: 'Generic Prompts',
            categoriesAndFields: 'Prompts & Fields',
            nodeFindings: 'Findings',
            nodeBuiltinFields: 'Built-in fields',
            nodeAllCategories: 'All categories',
            nodeVulnerabilities: 'Vulnerabilities',
            nodeSections: 'Sections',
            nodeAllSections: 'All sections',
            searchAllPlaceholder: 'Search',
            filterPlaceholder: 'Search by field name',
            globalCaption: 'Reusable prompts listed in the AI chat in this order (spellcheck, translation, style rewrites, etc.). Drag to reorder.',
            noGlobalPrompts: 'No generic prompts yet. Add one to expose document-wide actions in the AI chat.',
            noFieldsMatch: 'No fields match your search.',
            addGlobalPrompt: 'Add prompt',
            deleteSelected: 'Delete selected ({count})',
            deletePrompt: 'Delete prompt',
            deleteConfirmTitle: 'Delete generic prompt(s)',
            deleteConfirmMessage: 'Delete {count} generic prompt(s)? This cannot be undone.',
            deleteSuccess: '{count} generic prompt(s) deleted',
            columnField: 'Field',
            columnPrompt: 'Prompt',
            aiAssist: 'AI Assist',
            label: 'Label',
            labelHint: 'Shown in the AI chat (e.g. Spellcheck my document)',
            enabled: 'Enabled',
            disabled: 'Désactivé',
            prompt: 'Prompt',
            newPrompt: 'New prompt',
            saveChanges: 'Save changes',
            resetToDefault: 'Reset to default',
            resetConfirmTitle: 'Reset prompt',
            resetConfirmMessage: 'Reset the "{field}" prompt to its default text?',
            resetSuccess: 'Prompt reset to default',
            discardChangesTitle: 'Unsaved changes',
            discardChangesMessage: 'You have unsaved changes to this prompt. Discard them and continue?',
            variablesTitle: 'Available variables',
            saveSuccess: 'Assisted writing prompts updated successfully',
            saveFailed: 'Failed to update assisted writing prompts',
            unsavedChanges: '{count} unsaved change(s)',
            outputTypeHtml: 'HTML',
            outputTypeList: 'List',
            outputTypeText: 'Text'
        },
        guidelines: {
            description: 'Organization-wide writing rules provided to every AI request as additional context. Use plain text or Markdown, similar to a project style guide.',
            readOnly: 'Read-only: you do not have permission to update writing guidelines.',
            label: 'Writing guidelines',
            hint: 'Examples: tone, terminology, data redaction rules, forbidden disclosures, report structure conventions.',
            save: 'Save guidelines',
            saveSuccess: 'Writing guidelines updated successfully',
            saveFailed: 'Failed to update writing guidelines'
        },
        qa: {
            description: 'Configure which automated checks run when reviewing audit reports and vulnerability templates.',
            readOnly: 'Read-only: you do not have permission to update QA settings.',
            aiChecksDisabledChip: 'Désactivé',
            aiChecksDisabledBefore: 'L\'intégration IA est désactivée. Activez-la dans',
            aiChecksDisabledLink: 'Paramètres',
            aiChecksDisabledAfter: 'pour exécuter les vérifications assistées par IA.',
            instructionsTitle: 'QA instructions',
            instructionsDescription: 'Organization-wide QA checklist provided to the AI reviewer. Use plain text or Markdown to define additional required sections, fields, and report rules beyond the minimum completeness check.',
            instructionsLabel: 'QA instructions',
            instructionsHint: 'Examples: require executive summary and scope sections, mandate remediation text, verify customer naming, retest wording.',
            save: 'Save QA settings',
            saveInstructions: 'Save instructions',
            saveSuccess: 'QA settings updated successfully',
            saveFailed: 'Failed to update QA settings',
            saved: 'Saved',
            checkCompletenessLabel: 'Report completeness',
            checkCompletenessDescription: 'Minimum report requirements only: audit name, at least one finding, and finding titles. Findings still in redaction are flagged as warnings.',
            checkReferencesLabel: 'Reference links',
            checkReferencesDescription: 'Validate that HTTP(S) URLs listed in finding references are reachable.',
            checkImageCaptionsLabel: 'Image captions',
            checkImageCaptionsDescription: 'Flag images and figure captions that still use the imported filename (for example screenshot.png).',
            checkDuplicatesLabel: 'Duplicate templates',
            checkDuplicatesDescription: 'Fast structural checks for templates in the same language with the same title or identical description, observation, and remediation content.',
            checkAiDuplicatesLabel: 'AI duplicate templates',
            checkAiDuplicatesDescription: 'AI review to identify templates that describe the same underlying vulnerability even when titles differ or content is paraphrased.',
            checkAiUnlinkedTranslationsLabel: 'AI unlinked translations',
            checkAiUnlinkedTranslationsDescription: 'AI review to identify the same vulnerability template stored in separate records for different languages instead of being merged into one multilingual record.',
            checkRedactionLabel: 'Writing guidelines review',
            checkRedactionDescription: 'AI review of report content against organization writing guidelines.',
            checkCustomerLabel: 'Customer alignment',
            checkCustomerDescription: 'AI review that the report content matches the expected customer and company.',
            checkInstructionsLabel: 'QA instructions',
            checkInstructionsDescription: 'AI review against organization QA instructions below, including any additional required sections or fields you define.',
            usesTokens: 'Uses tokens',
            scopeAudit: 'Audit reports',
            scopeVulnerability: 'Vulnerability database'
        },
        settingsCard: {
            title: 'AI Integration',
            disableHint: 'Disable to fully hide AI prompt configuration and AI generation buttons for all users.',
            providerTitle: 'AI Provider'
        },
        menu: {
            assistedWriting: 'Assisted Writing',
            qualityAssurance: 'Quality Assurance'
        },
        provider: {
            defaultBadge: 'Default',
            setDefaultLabel: 'Set as default provider',
            setDefaultHint: 'Used when a request does not specify a provider. Always available to users.',
            configuredHint: 'This provider is configured',
            allowUsersLabel: 'Allow users to select this provider',
            allowUsersHint: 'When enabled, users can pick this provider for AI generation and QA. The default provider is always available.',
            openaiBaseUrl: 'OpenAI Base URL',
            openaiModel: 'OpenAI Model',
            openaiApiKey: 'OpenAI API Key',
            anthropicBaseUrl: 'Anthropic Base URL',
            anthropicModel: 'Anthropic Model',
            anthropicVersion: 'Anthropic Version',
            anthropicApiKey: 'Anthropic API Key',
            deepseekBaseUrl: 'DeepSeek Base URL',
            deepseekModel: 'DeepSeek Model',
            deepseekApiKey: 'DeepSeek API Key',
            ollamaBaseUrl: 'Ollama Base URL',
            ollamaModel: 'Ollama Model',
            ollamaApiKey: 'Ollama API Key',
            awsRegion: 'AWS Region',
            bedrockModelId: 'Bedrock Model ID',
            bedrockCredentialsHint: 'Configure either a Bedrock API key or IAM credentials.',
            bedrockApiKey: 'Bedrock API Key',
            awsAccessKeyId: 'AWS Access Key ID',
            awsSecretAccessKey: 'AWS Secret Access Key',
            awsSessionToken: 'AWS Session Token (optional)',
            testConnection: 'Test connection',
            testSuccess: 'Connection successful',
            testSuccessWithModel: 'Connection successful (model: {model})',
            testFailed: 'Connection failed'
        }
    },
    aiChat: {
        providerLabel: 'Provider',
        selectedText: 'Texte sélectionné',
        startPrompt: 'Décrivez comment vous voulez modifier le texte sélectionné.',
        reviewDefaultPrompt: 'Choisissez une invite ou posez votre question.',
        defaultPromptPlaceholder: 'Posez votre question',
        askAnything: 'Posez votre question',
        defaultPromptOption: 'Valeur par défaut du champ',
        promptSelectLabel: 'Modèle d\'invite',
        howCanIHelp: 'Comment puis-je vous aider ?',
        quickPrompts: 'Invites rapides',
        quickPromptsHint: 'Commencez avec la valeur par défaut du champ ou choisissez une invite réutilisable.',
        searchPrompts: 'Rechercher des invites...',
        searchResults: 'Résultats de recherche',
        fieldPrompt: 'Invite du champ',
        defaultPromptHint: 'Utilise les instructions prédéfinies configurées pour ce champ.',
        usePrompt: 'Utiliser',
        recentPrompts: 'Récentes',
        allPrompts: 'Toutes les invites',
        browsePrompts: 'Parcourir les invites',
        noPromptsFound: 'Aucune invite ne correspond à votre recherche.',
        applyField: 'Appliquer au champ',
        previewChanges: 'Aperçu des modifications',
        originalResponse: 'Réponse originale',
        inputPlaceholder: 'Demandez à l\'IA de réécrire la sélection...',
        sendHint: 'Astuce : appuyez sur Ctrl+Entrée pour envoyer.',
        send: 'Envoyer',
        stop: 'Arrêter la génération',
        apply: 'Appliquer à la sélection',
        you: 'Vous',
        assistant: 'Assistant',
        updatedDraft: 'Voici une version mise à jour du texte sélectionné.',
        emptyDraft: 'La réponse de l\'IA est vide',
        requestFailed: 'Impossible de générer la réponse de l\'IA',
        timedOut: 'La requête a expiré. Cela peut arriver sur les requêtes complexes — votre message a été conservé, réessayez.',
        noSelection: 'Sélectionnez du texte dans le champ avant d\'utiliser l\'IA.',
        generating: 'Génération du contenu...',
        leaveWhileGeneratingTitle: 'Génération IA en cours',
        leaveWhileGeneratingMessage: 'Le contenu est encore en cours de génération. Quitter maintenant annulera la requête IA en cours.',
        closeWhileGeneratingMessage: 'Le contenu est encore en cours de génération. Fermer quand même le panneau IA ?',
        discardAiSessionTitle: 'Abandonner la session IA ?',
        discardAiSessionMessage: 'Le champ sera déverrouillé et la conversation IA actuelle sera perdue.',
        discardAndStart: 'Abandonner et recommencer',
        leaveWhileAiSessionMessage: 'Ce champ est verrouillé par une session IA active. Quitter maintenant l\'abandonnera.',
        activeSession: 'Terminez ou fermez la session IA actuelle avant d\'en démarrer une autre.',
        applySelection: 'Appliquer la sélection',
        insertAtCursor: 'Insérer au curseur',
        anchorCollapsed: 'Le texte sélectionné a été supprimé. Le brouillon sera inséré à sa position d\'origine.',
        anchorLost: 'La sélection d\'origine n\'a pas pu être suivie. Resélectionnez le texte et réessayez, ou copiez la réponse manuellement.',
        tooltip: 'Assistant IA'
    },
}
